import {useEffect, useRef} from 'react';
import styled from 'styled-components';
import {Footer} from '@/components/Footer';
import {NavBar} from '@/components/NavBar';
import {MobileNavBar} from '@/components/NavBar/MobileNavBar';
import {PricingTable} from '@/components/Pricing';
import {useBreakpoints, useSession} from '@/hooks';
import {useAirbridgeTracking} from '@/hooks/tracking';
import {
  FlexFullGrow,
  HorizontalFullContainer,
  ScrollBody,
} from '@/styled-components';

const Pricing = () => {
  const trackAirbridge = useAirbridgeTracking();
  const isTracked = useRef<boolean>(false);
  const {isPending} = useSession();
  const {isMobile} = useBreakpoints();
  useEffect(() => {
    if (isTracked.current || isPending) {
      return;
    }

    trackAirbridge('view_intro_page');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPending]);

  return (
    <HorizontalFullContainer>
      {isMobile ? <MobileNavBar /> : <NavBar />}
      <Body>
          <PricingTable viewOnly={isMobile} />
          <FlexFullGrow />
          <Footer />
      </Body>
    </HorizontalFullContainer>
  );
};

const Body = styled(ScrollBody)`
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export default Pricing;
